import React from 'react';
import struct from 'observ-struct';

import queryString from '../../../../utils/QueryString.js';
import ObservApi from '../../../../lib/observable-api.js';

import EditorController from './EditorController';

import PreferenceStore from './stores/PlayerStore';
import { wrap } from '../../../lib/playerPreferences';

import AssetStore from '../../../../metadata/components/assets/Store.js';
import reduxStore from '../../../../redux/store';

import InvalidPermissions from '../../../InvalidPermissions';

var PREF_ID = false;

export default function createPlayerPrefEditor (api, socket, options) {
    PREF_ID = queryString.parse(window.location.search).id || false;

    var playerApi = ObservApi(api.player);
    var preferenceStore = PreferenceStore(playerApi.bus);

    if (!PREF_ID) {
        preferenceStore.init();
    }

    // var channelApi = ObservApi(api.channels);
    // var channelStore = ChannelStore(channelApi.bus);

    var assetApi = ObservApi(api.assets);
    var assetStore = AssetStore(assetApi.bus, socket);

    var state = window.state = struct({
        preference: preferenceStore.state,
        // channels: channelStore.state,
        assets: assetStore.state,
        peerStatus: struct({
            enabled: false
        })
    });

    function getId () {
        let id = false;
        try {
            id = state().preference.preferenceID;
        } catch (e) {
            console.log(e);
        } finally {
            if (!id) id = PREF_ID;
            return id;
        }
    }

    var actions = {
        playerPreference: playerApi.actions,
        // channelPreferences: channelApi.actions,
        getMiscAssets: function () {
            assetApi.actions.getMiscAssets(function (err, resp) {
                if (!err) {
                    state.assets.set({
                        isResolving: false,
                        data: resp.data
                    });
                }
            });
        },

        getP2Pstatus: function () {
            api.p2p.getP2Pstatus(function (err, resp) {
                if (
                    !err &&
                    resp.data &&
                    resp.data.hasOwnProperty('enabled') &&
                    resp.data.enabled != state.peerStatus().enabled
                ) {
                    state.peerStatus.set(resp.data);
                }
            });
        },

        handleSave: function (preference, cb) {
            const id = getId();
            const { name, ...properties } = preference;
            const clientID = reduxStore.getState().data.user.clientId;
            const payload = wrap({
                clientID,
                prefID: id || undefined,
                name,
                properties,
            });
            const action = (!id) ? 'add' : 'edit';
            playerApi.actions[action](payload, cb);
        },

        // ----- Theme fan-out -----
        //
        // Both calls deliberately go straight at `api.player` instead of
        // through `playerApi.actions`. The Observ actions publish onto the
        // bus that PlayerStore subscribes to, so a list response would be
        // handled as if it were this editor's own preference and would
        // replace the bag being edited. Fan-out has to touch OTHER
        // preferences without disturbing the one on screen.

        listPreferences: function (cb) {
            // clientID is attached to every request body by the api
            // adapter, so an empty body returns this client's preferences.
            api.player.get({}, cb);
        },

        fanOutSave: function ({ prefID, name, properties }, cb) {
            const clientID = reduxStore.getState().data.user.clientId;
            api.player.edit(wrap({ clientID, prefID, name, properties }), cb);
        }
    };

    class PlayerPrefEditor extends React.Component {
        constructor (props) {
            super(props)
        }

        render () {

            var props = {
                store: state,
                actions: actions,
                preferenceID: getId,
                // Read at render rather than module load: the user (and
                // therefore the client) is not resolved when this module
                // is first evaluated.
                clientID: reduxStore.getState().data.user.clientId
            };

            return <EditorController {...this.props} {...props}/>;
        }
    }

    return PlayerPrefEditor;
};
